import { render } from "./TooltipDropdown.vue?vue&type=template&id=49cacb34&scoped=true"
import script from "./TooltipDropdown.vue?vue&type=script&lang=js"
export * from "./TooltipDropdown.vue?vue&type=script&lang=js"

import "./TooltipDropdown.vue?vue&type=style&index=0&id=49cacb34&scoped=true&lang=scss"

import exportComponent from "C:\\Bohdan\\telesim_test\\telesim-admin-panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49cacb34"]])

export default __exports__